import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../../assets/PathianCurves.png';
import { useAuth } from '../../providers/AuthenticationProvider';
import { Dimmer, Loader } from 'semantic-ui-react';

const containerStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '87vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
};

const signInStyle = {
    fontSize: '25px',
    color: '#00A7B5',
    margin: '10px',
    display: 'flex',
    justifyContent: 'flex-start',
    wordSpacing: '-0.2em',
};

const welcomeStyle = {
    fontSize: '40px',
    color: '#00A7B5',
    margin: '10px',
    display: 'flex',
    justifyContent: 'flex-start',
    wordSpacing: '-0.2em',
};

const linkStyle = {
    color: '#00A7B5',
    fontSize: '15px',
    fontWeight: 'bolder',
};

export const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { login, isLoggedIn, loading, loginError } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn) {
            navigate('/reports')
        }
    }, [navigate, isLoggedIn]);

    const handleSubmit = e => {
        e.preventDefault();
        navigate('/');
        login(email, password);
    };

    if (loading) {
        return (
            <Dimmer active={loading} inverted>
                <Loader active={loading} size="massive" inline />
            </Dimmer>
        );
    }

    return (
        <>
            <div
                style={containerStyle}
                className="Franklin-font"
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '0 0 13%',
                        marginRight: '35px',
                    }}
                >
                    <p style={welcomeStyle}>Welcome</p>
                    <p style={signInStyle}>Please sign in to continue.</p>
                </div>
                <div>
                    <form onSubmit={handleSubmit}>
                        <div className="login">
                            <label
                                style={{
                                    fontSize: '20px',
                                    color: '#254A5D',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                }}
                            >
                                Username
                            </label>
                            <input
                                type="text"
                                name="Username"
                                id="Username"
                                placeholder="Username"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                            ></input>
                            <br />

                            <label
                                style={{
                                    fontSize: '20px',
                                    color: '#254A5D',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                }}
                            >
                                Password
                            </label>
                            <input
                                type="Password"
                                name="Pass"
                                id="Pass"
                                placeholder="Password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                required
                            ></input>
                            <br />

                            <a href="/forgot-password" style={linkStyle} className="links">
                                Forgot Password?
                            </a>
                            <br />

                            <button type="submit" name="logIn" id="logIn" value="Login">
                                Login
                            </button>
                            <br />
                            <br />
                            <div style={{ textAlign: 'center' }}>
                                <span style={{ color: '#254A5D', fontSize: '14px' }}>
                                    Don't have an account?{' '}
                                </span>
                                <a href="/signup" style={linkStyle} className="links">
                                    Sign up
                                </a>
                            </div>
                            {loginError && <p style={{ color: 'red' }}>{loginError}</p>}
                            <br />
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};
